import {useContext, useEffect} from "react";
import {SetRootNavbarOn} from "../Navigation/NavigationFooter";
import {AddBackButtonAction} from "./BackButtonProvider";
import {createPortal} from "react-dom";

export type PopupContentProps<T> = {
    isOpen: boolean,
    closePopup: () => void,
    data: T
}

export type PopupProps<T> = {
    data: T
    contentFactory: (props: PopupContentProps<T>) => JSX.Element,
    isOpen: boolean,
    setIsOpen: (v : boolean) => void
    zIndex: number
}

export function Popup<T>(props: PopupProps<T>) {
    const showNavbar = useContext(SetRootNavbarOn);
    const addBackButtonAction = useContext(AddBackButtonAction);

    useEffect(() => {
        showNavbar(!props.isOpen)
    }, [props.isOpen]); // eslint-disable-line

    const closePopup = () => {
        showNavbar(true);
        props.setIsOpen(false);
    }

    useEffect(() => {
        if(!props.isOpen) return;

        addBackButtonAction({
            id: "close-popup",
            fn: closePopup
        });
    }, [props.isOpen]); // eslint-disable-line

    const content = props.contentFactory({
        isOpen: props.isOpen,
        closePopup: closePopup,
        data: props.data
    });

    const outerClassName = props.isOpen ? "full-screen" : "full-screen click-through"
    return <> {createPortal(
        <div className={outerClassName}> {content} </div>,
        document.body
    )} </>;
}

export function RawPopup<T>(props: PopupProps<T>) {
    const addBackButtonAction = useContext(AddBackButtonAction);

    const closePopup = () => {
        props.setIsOpen(false);
    }

    const content = props.contentFactory({
        isOpen: props.isOpen,
        closePopup: closePopup,
        data: props.data
    });

    useEffect(() => {
        if(!props.isOpen) return;

        addBackButtonAction({
            id: "close-popup",
            fn: closePopup
        });
    }, [props.isOpen]); // eslint-disable-line

    const outerClassName = props.isOpen ? "full-screen" : "full-screen click-through"
    return <> {createPortal(
        <div className={outerClassName} style={{zIndex: props.zIndex}}> {content} </div>,
        document.body
    )} </>;
}